import React, { useState } from 'react';
import { FiSearch } from 'react-icons/fi';

function SearchBoxMagnifyingGlass() {

  const [text, setText] = useState('');
  const [click, setClick] = useState(false);
  
  const handleSubmit = (event:any) => {
    event.preventDefault();
    if(text.length > 0) {
      window.location.replace(`/find/${text}`);
    }
  };

  const handleClickOutside = () => {  
      setClick(false);
      setText('');
  };
  
  return (
      <form className={click ?'formMagnifyingGlass clicked transition': 'formMagnifyingGlass transition'} 
            onSubmit={handleSubmit}
            onBlur={ handleClickOutside}>
        <FiSearch 
          className= {click ? 'iconMagnifyingGlassClicked' : 'iconMagnifyingGlass'}
          onClick={()=> setClick(true) }
        ></FiSearch>       
     
        <input 
               className= {click ? 'inputMagnifyingGlassOn' : 'inputMagnifyingGlassOff transition'}
               role={'searchbox'}
               aria-labelledby="textdiv"
               type='text'
               value={text}
               onChange={event => setText(event.target.value)}   
               placeholder={'Search'}
               ref={input => input && input.focus()}
        />
      </form>
  );
}

export default SearchBoxMagnifyingGlass;